import { Button, Grid } from "@mui/material";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { AppContextProps, useAppContext, } from "../../../libs/app-core/AppContext";
import { Toast } from "../../../libs/app-core/Toast";
import { useGridApiRef } from "../../../libs/data-grid-view/useGridApiRef";
import { linear_item, linear_v, } from "../../../libs/linear-layout/LinearLayout";
import { UniAnswer } from "../../dao/UniAnswer";
import { UniForm } from "../../dao/UniForm";
import { SpwkMetaData } from "../../export_spwk/SpwkMetaData";
import { useSpwkQuestV3 } from "../FrmSpwkQuestV3/useSpwkQuestV3";
import { MessageDialog } from "../../../libs/app-core/dialogs/MessageDialog";
import { MenuDialog } from "../../../libs/app-core/dialogs/MenuDialog";
import { ExportBundle } from "../../export_spwk/ExportBundle";
import { ExportManager } from "../../export_spwk/ExportManager";
import { HisDtoManager, HisDtoResult } from "../../export_spwk/HisDtoManager/HisDtoManager";
import { DialogButtons } from "../../../libs/app-core/dialogs/DialogButtons";

type Props = {};

const FrmSpwkExportTest = (props: Props) => {
  const ctx = useAppContext();

  const [searchParams] = useSearchParams(); // UrlQueryParams

  let answer_guid: any = searchParams.get("answer_guid");

  // TODO: 這裡要撈出整個場次的 Answer快取 + 所有用到的 BaseForm + 所有用到的 特作FormList
  // Foreach member，從快取找出這3個(答案 + 基礎設定 + 特作設定列表)
  // 對所有的 特作設定列表，補上缺少的答案 如 以上皆無...
  // 然後再執行匯出

  // 以下先簡化為，對單一受檢者作轉檔的動作

  //

  /* 核心變數: 此 Answer 與其通用問題 + 特作版本列表 */
  let { _UniAnswer, _SpwkBaseForm, _UniFormList } = useSpwkQuestV3(answer_guid, undefined, false); // $$$

  const [批次轉檔結果Bundle, set_批次轉檔結果Bundle] = useState<ExportBundle | null>(null);

  //------------------------------------------------------------ Main()

  // 將每個人的 Answer 指定的格式，打平成 Excel，並在尾部加上可以填寫欄位的地方

  // 注意! FormList 已經填好樹狀結構，且應該唯讀

  // 以下開始進行轉檔

  // 對所有 特作表單
  // 跑基本框架 基本資料、作業經歷、檢查時期.....
  // 產出 Excel 格式
  // 補上額外填寫的答案
  // 調整如A98 輸出的格式差異

  // 格式1: 填到問卷基本檔 的 某個 Column
  // 格式2: 類別+項目+結果+備註  4_19#左手腕@4_20#左手腕
  // 格式3: 生活型態 5_1_4#10@0
  // 格式4: 環境
  // 各式5: B02 聽力 特殊
  // 格式6: A98: 00001,00001,00100,00001,00001,00001...

  const grid_api = useGridApiRef(columns);

  return (
    <>
      <Grid {...linear_v}>
        <Grid container {...linear_item} spacing={1} padding={1}>
          <Grid item>
            <Button onClick={() => { btn_轉換為metadata_Click(); }} children={"轉換為 metadata"} variant="contained" size={"small"} />
          </Grid>
          <Grid item>
            <Button onClick={() => { btn_查看metadata_Click(); }} children={"查看 metadata"} size={"small"} />
          </Grid>
          <Grid item>
            <Button onClick={() => { btn_ConvertToHisDto_Click(); }} children={"轉換為院內系統格式(TODO)"} variant="contained" color={"error"} size={"small"} />
          </Grid>
        </Grid>
        <Grid {...linear_item} flex={1}>
          {render_DataGrid()}
        </Grid>
      </Grid>
    </>
  );

  function render_DataGrid(): React.ReactNode {
    let data_list: any[] =
      批次轉檔結果Bundle == null ? [] : 批次轉檔結果Bundle.AllMetaDataList;

    return (
      <DataGrid
        style={{ width: "100%", backgroundColor: "white", padding: "12px" }}
        rows={data_list}
        columns={grid_api.columns}
        density={"compact"}
        pageSize={100}
        rowsPerPageOptions={[100]}
        hideFooterSelectedRowCount

        onCellEditCommit={async ({ id, field, value }) => { }}
      />
    );
  }

  function btn_轉換為metadata_Click() {
    if (_UniAnswer == null || _SpwkBaseForm == null || _UniFormList == null) {
      alert("ERROR! 不應該為 null");
      return;
    }

    /** 答案List: 不論用什麼方式，取得一票需要轉檔的 Anwsers (TODO) */
    const CACHE_ANSWER_LIST: UniAnswer[] = [_UniAnswer];

    /** 表單基礎檔快取: 以上答案會用到的基礎檔，撈出來填好樹狀結構備用 (TODO) */
    const CACHE_BASE_FORM_LIST: UniForm[] = [_SpwkBaseForm];

    /** 問卷定義檔快取: 以上答案可能是由多個特作合併的，撈出來填好樹狀結構備用 (TODO) */
    const CACHE_SPWK_FORM_LIST: UniForm[] = [..._UniFormList];

    // $$$ 核心
    // 只要將符合規定的快取資料一次丟入這個方法，就會回傳一套轉好的資料
    // 未來加入開關，決定是否要轉出特定資料
    // 轉檔由中繼資料主責
    const [all_bundle_list, failed_answers, error_messages] = ExportManager.RunBatchExport(CACHE_ANSWER_LIST, CACHE_BASE_FORM_LIST, CACHE_SPWK_FORM_LIST);

    if (failed_answers.length === 0) {
      MessageDialog.Show(ctx, "轉換成功", "", {
        colorMeaning: "Success",
      });
    } else {
      MessageDialog.Show(ctx, failed_answers.map((x) => x.serno).join("\n") + "\n" + error_messages.join("\n"), `共有 ${failed_answers.length} 筆失敗!`,
        { colorMeaning: "Danger", }
      );
    }

    if (all_bundle_list.length !== 1) {
      alert(`44341 應該要剛好一筆! ${all_bundle_list.length}`);
      return;
    }

    set_批次轉檔結果Bundle(all_bundle_list[0]);

  }

  function btn_查看metadata_Click() {
    if (批次轉檔結果Bundle == null) {
      Toast.ShowWarning(ctx, "請先執行轉檔!");
      return;
    }

    MenuDialog.Show(
      ctx,
      [
        { value: "基本檔", label: "基本檔" },
        { value: "問卷資料行", label: "問卷資料行" },
        { value: "申報資料行", label: "申報資料行" },
      ],

      {
        onDialogResult(e) {
          if (e.DialogResult === "Yes") {
            if (e.Data === "基本檔") {
              ShowJsonDialog(ctx, "基本檔", 批次轉檔結果Bundle.AllHisBasicList);
            } else if (e.Data === "問卷資料行") {
              ShowJsonDialog(
                ctx,
                "問卷資料行",
                批次轉檔結果Bundle.AllHisRowList
              );
            } else if (e.Data === "申報資料行") {
              ShowJsonDialog(
                ctx,
                "申報資料行",
                批次轉檔結果Bundle.AllGovRowList
              );
            } else {
              Toast.Show(ctx, "未知的選擇: " + e.Data + " !!!");
            }
          }
        },
      }
    );
  }

  function btn_ConvertToHisDto_Click() {
    if (批次轉檔結果Bundle == null) {
      Toast.ShowDanger(ctx, "批次轉檔結果Bundle 為 null !!!");
      return;
    }

    let rslt: HisDtoResult = HisDtoManager.ConvertFromExportBundle(批次轉檔結果Bundle);
    if (rslt.HisDto != null && rslt.ErrorList.length === 0) {

      if (rslt.WarningList.length !== 0) {
        MessageDialog.Show(ctx, rslt.WarningList.join("\n"), "警告列表", {
          ...DialogButtons.Warning,
          onDialogResult(e) {
            if (e.DialogResult === 'Yes') {
              ShowJsonDialog(ctx, "HisDto", rslt.HisDto);
            }
          },
        });
      } else {
        ShowJsonDialog(ctx, "HisDto", rslt.HisDto);
      }
    } else {
      Toast.ShowDanger(ctx, "轉檔失敗!" + (rslt.ErrorList[0] ?? ""));
    }
  }
};

const columns: GridColDef<SpwkMetaData>[] = [
  {
    field: "func_code",
    headerName: "特作",
    width: 80,
    description: "特作代碼，代表同一份問卷",
  },
  { field: "chapter", headerName: "chapter", width: 120, description: "" },
  { field: "data_type", headerName: "type", width: 80, description: "" },
  { field: "kind", headerName: "kind", width: 80, description: "" },
  {
    field: "display_code",
    headerName: "display_code",
    width: 280,
    valueGetter: (params) => {
      const data = params.row as SpwkMetaData;
      return data.getDebugDisplayCode();
    },
  },

  {
    field: "is_need_value",
    type: "boolean",
    headerName: "需填",
    width: 80,
    editable: true,
  },

  { field: "rhf_name", headerName: "rhf_name", width: 480, description: "" },

  { field: "rhf_value", headerName: "rhf_value", width: 120, editable: true },

  { field: "q_his_rule", headerName: "q_his_rule", width: 120, editable: true },
  { field: "o_his_rule", headerName: "o_his_rule", width: 120, editable: true },
  { field: "i_his_rule", headerName: "i_his_rule", width: 120, editable: true },

  { field: "his_code", headerName: "his_code", width: 240, editable: true },
  { field: "q_gov_code", headerName: "q_gov_code", width: 120, editable: true },
  { field: "o_gov_code", headerName: "o_gov_code", width: 120, editable: true },
  { field: "i_gov_code", headerName: "i_gov_code", width: 120, editable: true },

  {
    field: "question_guid",
    headerName: "question_guid",
    width: 120,
    editable: true,
  },

  { field: "data_serno", headerName: "data_serno", width: 120, editable: true },
];

export default FrmSpwkExportTest;

function ShowJsonDialog(ctx: AppContextProps, title: string, data: any) {

  let json = JSON.stringify(data, null, 4);

  navigator.clipboard.writeText(json);

  MessageDialog.Show(ctx, json, title);
}